import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/auth";

const AdminLogin = () => {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Sign-in failed. Please check your details.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="min-h-[70vh] flex items-center border-b border-line" data-testid="admin-login">
      <div className="max-w-7xl w-full mx-auto px-6 lg:px-10 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-6 md:col-start-4 py-16">
          <p className="text-xs uppercase tracking-[0.28em] text-terracotta mb-4">Editor</p>
          <h1 className="font-serif text-4xl lg:text-5xl text-ink mb-3">Sign in to edit the guide.</h1>
          <p className="text-stone mb-10 leading-relaxed">
            Only editors update these pages. If you've reached this by accident,{" "}
            <Link to="/" className="prose-link">go back to the home page</Link>.
          </p>
          <form onSubmit={submit} className="space-y-4">
            <input
              data-testid="admin-email"
              type="email"
              required
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-line bg-paper px-4 py-3.5 text-sm focus:outline-none focus:border-ink"
            />
            <input
              data-testid="admin-password"
              type="password"
              required
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-line bg-paper px-4 py-3.5 text-sm focus:outline-none focus:border-ink"
            />
            {error && <p className="text-sm text-terracotta" data-testid="admin-error">{error}</p>}
            <button
              type="submit"
              disabled={busy}
              data-testid="admin-submit"
              className="btn-terracotta px-8 py-3.5 rounded-full text-sm font-medium disabled:opacity-60"
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default AdminLogin;
